import Store from 'store/store';
import { addClass, removeClass, accessNested } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getMainPage, getScroller } from 'utils/bolt';

let showtimesShowing = false;
let homeEntShowing = false;
let pressKitShowing = false;

Store.on('SWITCH_DUAL_VIEW', (page, isWidget) => {
	if (isWidget) {
		return;
	}

	const isShowtimes = page === 'showtimes';

	window.setTimeout(() => {
		closeSidePanel(false, false, isShowtimes ? 'homeEnt' : 'showtimes');
		showtimesShowing = isShowtimes;
		homeEntShowing = !isShowtimes;
		Store.emit('SET_ACTIVE_PAGE', isShowtimes ? 'boltShowtimes' : 'boltHomeEnt');
	}, 300);
	openSidePanel(false, isShowtimes ? 'showtimes' : 'homeEnt', true);
});

export const openSidePanel = (animate, comp, disableCloseAllOverlays, queryString, pageId) => {
	const isShowtimes = comp === 'showtimes';
	const isHomeEnt = comp === 'homeEnt';
	const isPressKit = comp === 'pressKit';
	const enabledGroupBookings = Store.get().appData?.pages?.boltShowtimes?.data?.groupBookings?.isEnabled;
	const isSamePage = pageId === Store.get().activePage;
	// gb hack
	if (isShowtimes && showtimesShowing && isSamePage && !enabledGroupBookings && queryString !== '?openFilters') return;
	if (isHomeEnt && homeEntShowing && isSamePage) return;
	if (isPressKit && pressKitShowing) return;

	if (!disableCloseAllOverlays) {
		Store.emit('CLOSE_ALL_OVERLAYS');
	}

	Store.get().set({ ignoreScroll: true });

	if (isShowtimes) showtimesShowing = true;
	if (isHomeEnt) homeEntShowing = true;
	if (isPressKit) pressKitShowing = true;

	const scroller = getScroller();

	const show = () => {

		if (isShowtimes) {
			Store.get().header.set({ showtimesOverlay: true });
			Store.get().showtimes.set({ show: pageId || true, animate });
			if (Store.get().showtimes.providerInterstitialOpen) {
				const actionData = {
					icon: 'back',
					action: () => Store.emit('CLOSE_PROVIDER_INTERSTITIAL')
				};
				const isDesktopSize = Store.get().client.isDesktopSize;
				isDesktopSize ? Store.emit('SET_SHOWTIMES_BTN_ACTIONS', actionData) : Store.emit('SET_HEADER_ACTION', actionData);
			}
			if (!showtimesShowing) return;
		}

		if (isHomeEnt) {
			Store.get().header.set({ homeEntOverlay: true });
			Store.get().homeEnt.set({ show: pageId || true, animate });
			if (!homeEntShowing) return;
		}

		if (isPressKit) {
			Store.get().header.set({ pressKitOverlay: true });
			Store.get().pressKit.set({ show: pageId || true, animate });
			if (!pressKitShowing) return;
		}

		Store.get().set({ ignoreScroll: false });
		Store.emit('UPDATE_VISIBILITY_PERCENTAGES');

		let newPageId = null;
		if (isShowtimes) {

			//gb hack to correctly show the active headerExpanded
			if (queryString === '?groupbookings') {
				Store.get().set({ groupBookingsShowtimes: true });
				Store.get().showtimes.set({ groupBookingsTabActive: true });
			}
			if (queryString === '?booknow') {
				Store.get().set({ groupBookingsShowtimes: false });
				Store.get().showtimes.set({ groupBookingsTabActive: false });
			}
			if (queryString === '?openFilters') {
				Store.emit('OPEN_SHOWTIMES_FILTERS', true);
			}
			//
			newPageId = pageId || 'boltShowtimes';
		} else if (isHomeEnt) {
			newPageId = pageId || 'boltHomeEnt';
		} else if (isPressKit) {
			newPageId = pageId || 'boltPressKit';
		}

		if (newPageId && newPageId !== Store.get().activePage) {
			Store.emit('SET_ACTIVE_PAGE', newPageId, queryString);
		}

		if (scroller) {
			setTimeout(() => {
				removeClass(scroller, 'nonInteractive');
			}, 500);
		}
	};

	if (scroller) {
		addClass(scroller, 'nonInteractive');
		smoothScrollTo(scroller, 0, !animate ? 0 : dist => Math.min(dist / 3, 200), {
			force: true,
			callback: show
		});
	} else {
		show();
	}
};


export const closeSidePanel = (animate, updateActivePage = true, comp) => {
	const isShowtimes = comp === 'showtimes';
	const isHomeEnt = comp === 'homeEnt';
	const isPressKit = comp === 'pressKit';

	if (isShowtimes && !showtimesShowing) return;
	if (isHomeEnt && !homeEntShowing) return;
	if (isPressKit && !pressKitShowing) return;

	const shareOpen = accessNested(Store.get(), 'header.shareOpen');
	if (shareOpen) {
		return;
	}

	if (isShowtimes) {
		showtimesShowing = false;
		Store.get().header.set({ showtimesOverlay: false });
		Store.get().showtimes.set({ show: false, animate });
		Store.emit('EXIT_CINEMA_DETAIL_VIEW');
		Store.emit('CLOSE_PROVIDER_INTERSTITIAL');
	}

	if (isHomeEnt) {
		homeEntShowing = false;
		Store.get().header.set({ homeEntOverlay: false });
		Store.get().homeEnt.set({ show: false, animate });
	}

	if (isPressKit) {
		pressKitShowing = false;
		Store.get().header.set({ pressKitOverlay: false });
		Store.get().pressKit.set({ show: false, animate });
	}

	if (updateActivePage) {
		const page = Store.get()[comp]?.returnToPage || getMainPage();
		Store.emit('SET_ACTIVE_PAGE', page);
		Store.emit('CHANGE_ACTIVE_SECTION', page, { instant: true });
	}
};
